<script setup lang="ts">

import type { AccountInfo, PublicClientApplication } from "@azure/msal-browser";
import { AuthService } from "@/service/AuthService";
import { inject, onMounted, ref } from "vue";


const msalInstance = inject("msalInstance") as PublicClientApplication;

const user = ref<AccountInfo | null>(null);
const isAuthenticated = ref(false);

onMounted(() => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    user.value = accounts[0];
    isAuthenticated.value = true;
  }
});

const login = async () => {
  try {
    var popupRequest = AuthService.loginRequest();
    const response = await msalInstance.loginPopup(popupRequest);
    user.value = response.account;
    isAuthenticated.value = true;
  } catch (err) {
    console.error("Login failed:", err);
  }
};

const logout = () => {
  msalInstance.logoutPopup();
  user.value = null;
  isAuthenticated.value = false;
};
</script>

<template>
  <div>
    <div v-if="!isAuthenticated">
      <button @click="login">Login</button>
    </div>
    <div v-else>
      <p>Welcome, {{ user?.name }}</p>
      <button @click="logout">Logout</button>
    </div>
  </div>
</template>

